import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaLoginComponent } from './okta-login/okta-login.component';
import { OktaRedirectComponent } from './okta-redirect/okta-redirect.component';
import { SignoutComponent } from './signout/signout.component';

const routes: Routes = [
  { path: 'login', component: OktaLoginComponent },
  { path: 'redirect', component: OktaRedirectComponent },
  { path: 'signout', component: SignoutComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
